
/**
 * BaseLoader
 * Should be as abstract as possible. Do not inject stuff for specific cases. In this case create a new Loader
 *
 * loads xhr for specific nodes
 * how to use: data-tncp-autoloader="base" data-tncp-xhr="/this/is/my/resource"
 *
 */
export default class BaseLoader {

    // constructor
    constructor(selector) {
        this.elements = $(selector); // selector e.g. [data-tncp-autoloader="base"]
        this.execute();
    }

    // execute
    // loops through selector "this.elements"
    execute() {
        let vm = this;
        vm.elements.each(function() {
            const $element = $(this);
            const dataAttributes = $element.data();

            vm.request = window.xhrRequest({
                url: dataAttributes.tncpXhr
            });

            vm.request.then((response) => {
                vm.onSuccess($element, response);
            });

            vm.request.catch((response) => {
                vm.onError($element, response);
            });
        });
    }

    onSuccess($element, response) {
        $element.html(response.data.content);
    }

    onError($element, response) {
        $element.html(response.data.content);
    }

}

